jQuery(function ($) {

    function memorials() {

        var timer;
        var hidden = true;
        $('.truncate').css('display', 'none'); //Hide the extra text


        // var curHeight = $('.single-memorial__bottom').outerHeight(); //Onload get the current height of the mem bottom
        // $('.single-memorial__hidden').css({'height': curHeight}); //Set the hidden element to the same height as the bottom

        // window.onresize = function () {
        //     clearTimeout(timer);
        //     timer = setTimeout(function () {
        //         curHeight = $('.single-memorial__bottom').outerHeight(); //reset height on resize
        //         $('.single-memorial__hidden').css({'height': curHeight});
        //     }, 50);
        // };

        $("[data-memorial-button]").click(function (e) {
            e.preventDefault();

            currEleID = $(this).data('memorialButton');

            if ($("[data-memorial-button=" + currEleID + "]").text() === "Read this memorial" && !$("[data-memorial-bottom=" + currEleID + "]").hasClass('move-done')) {

                curHeight = $("[data-memorial-bottom=" + currEleID + "]").outerHeight();
                $("[data-memorial-hidden=" + currEleID + "]").css({'height': curHeight});
                $("[data-memorial-bottom=" + currEleID + "]").animate({'height': '100%'});
                $("[data-memorial-truncate=" + currEleID + "]").show('100');
                $("[data-memorial-button=" + currEleID + "]").text('Back to photo');
                $("[data-memorial-read=" + currEleID + "]").hide();
                $("[data-memorial-button=" + currEleID + "]").attr("disabled", true);

                setTimeout(function(){
                    $("[data-memorial-bottom=" + currEleID + "]").addClass("move-done");
                    $("[data-memorial-button=" + currEleID + "]").attr("disabled", false);
                }, 300);


            } else if ($("[data-memorial-button=" + currEleID + "]").text() === "Back to photo" && $("[data-memorial-bottom=" + currEleID + "]").hasClass('move-done')) {
                $("[data-memorial-bottom=" + currEleID + "]").animate({'height': curHeight});
                $("[data-memorial-truncate=" + currEleID + "]").hide('100');
                $("[data-memorial-button=" + currEleID + "]").text('Read this memorial');
                $("[data-memorial-read=" + currEleID + "]").show();
                $("[data-memorial-button=" + currEleID + "]").attr("disabled", true);

                setTimeout(function(){
                    $("[data-memorial-bottom=" + currEleID + "]").removeClass("move-done");
                    $("[data-memorial-button=" + currEleID + "]").attr("disabled", false);
                }, 300);
            }
        })
    }

    $('.memorialise-index-block__wrapper').on( 'append.infiniteScroll', function( event, response, path, items ) {
        memorials();
    });

    memorials();
});